module.exports = __webpack_public_path__ + "img/Vector7.2812c1d2.svg";